module.exports = __webpack_public_path__ + "static/media/ic_dustbin_unselected.5ede0bf4.svg";